import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { DEFAULT_SELECT_OPTION } from '@app/constants/constants';
import { AutoUnsubscribe } from '@app/decorator/auto-unsubscribe.decorator';
import { AppearanceOptions } from '@app/enum/appearance-options.enum';
import { TokenStorageService } from '@app/service/token-storage.service';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-select',
    templateUrl: 'select.component.html',
    styleUrls: ['select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectComponent),
            multi: true,
        },
    ],
})
@AutoUnsubscribe
export class SelectComponent implements ControlValueAccessor, OnInit {
    @Input() formControlName: string;
    @Input() options = [];
    @Input() label: string;
    @Input() fontColor: string = 'dark';
    @Input() required = false;
    @Input() hasError = false;
    @Input() isFocused = false;
    @Input() errorMessage = '';
    @Input() hiddenSelectOption = true;
    @Output() valueChange = new EventEmitter<any>();
    @Input() disabled: boolean;
    @Input() isTranslated = false;
    @Input() isIconDisplayed = false;
    @Input() isNotSelectable = false;
    @Input() messageUponOptionSelection: string;
    @Input() iconUponOptionSelection: string;
    @Input() selectedOption = DEFAULT_SELECT_OPTION;
    @Input() initOption: number = -1;
    @Input() placeholder: string = 'globalconstant.select-option';
    isDark: boolean = false;
    darkModeSubscription: Subscription = this.tokenStorageService.appearance$.subscribe((option) => {
        this.isDark = option === AppearanceOptions.DARK;
    });
    @Input() formFieldClass: string = '';

    constructor(private tokenStorageService: TokenStorageService) {}

    ngOnInit(): void {
        this.valueChange.emit(this.selectedOption);

        if (this.initOption > -1) {
            this.selectedOption = this.options[this.initOption].id;
            this.valueChange.emit(this.selectedOption);
        }
    }

    writeValue(value: any) {
        this.selectedOption = value;
        this.valueChange.emit(this.selectedOption);
    }

    propagateChange: (_: any) => void = undefined;

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
        // TODO implement on touch fn
    }

    onSelectChange({ value }: MatSelectChange) {
        this.selectedOption = value;
        if (this.propagateChange) {
            this.propagateChange(this.selectedOption);
        }
        this.valueChange.emit(this.selectedOption);
    }

    setFocused(value: boolean) {
        this.isFocused = value;
    }
}
